module.exports = ".not-active {\n    pointer-events: none;\n    cursor: default;\n}"